var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20030_140807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.333 13.3335V9.3335H11.333",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 2.6665V6.6665H4.66699",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6603 5.99989C13.3222 5.04441 12.7476 4.19016 11.99 3.51683C11.2325 2.84351 10.3167 2.37306 9.32813 2.14939C8.33959 1.92572 7.31049 1.95612 6.33686 2.23774C5.36324 2.51936 4.47682 3.04303 3.76033 3.75989L0.666992 6.66655M15.3337 9.33322L12.2403 12.2399C11.5238 12.9567 10.6374 13.4804 9.66379 13.762C8.69016 14.0437 7.66106 14.0741 6.67252 13.8504C5.68397 13.6267 4.76819 13.1563 4.01064 12.4829C3.25308 11.8096 2.67844 10.9554 2.34033 9.99989",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20030_140807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/ResetIcon.44a723cc6bd936f913a81cf23b6e6343.svg";
export { ForwardRef as ReactComponent };